<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps({
  method: {
    default: 'GET',
    type: String as PropType<ApiEndpointMethodMethod>,
  },
})

const badgeColor = computed(() => {
  switch (props.method) {
    case 'DELETE':
      return 'rose'
    case 'GET':
      return 'violet'
    case 'PATCH':
      return 'emerald'
    case 'POST':
      return 'blue'
    case 'PUT':
      return 'amber'
    default:
      return 'gray'
  }
})
</script>

<template>
  <UBadge
    class="uppercase"
    :color="badgeColor"
    :label="method"
    size="xs"
    variant="subtle"
  />
</template>
